<div class="trip-card">
  <!-- Header (teal bar) -->
  <div class="trip-card__header">
    <span class="trip-card__reference">{{ view.reference }}</span>
    @if (view.chips.length) {
      <span class="trip-card__chips">
        @for (chip of view.chips; track chip; let last = $last) {
          <span class="trip-card__chip">{{ chip }}</span>
          @if (!last) {
            <span class="trip-card__chip-plus">+</span>
          }
        }
      </span>
    }
  </div>

  <!-- Sub-header: traveller + travel date -->
  <div class="trip-card__sub-header">
    @if (view.travellerName) {
      <span class="trip-card__traveller">{{ view.travellerName }}</span>
    }
    @if (view.travelDate) {
      <span class="trip-card__travel-date">
        <span i18n="@@chatTripCardTravelDate">Travel date -</span> {{ view.travelDate }}
      </span>
    }
  </div>

  <!-- Per item section -->
  @for (item of view.items; track $index) {
    <div class="trip-card__item">
      <div class="trip-card__item-header">
        <span class="trip-card__item-label">{{ item.label }}</span>
        @if (item.isBooked) {
          <span class="trip-card__pill trip-card__pill--booked" i18n="@@chatTripCardStatusBooked"
            >Booked</span
          >
        } @else if (item.status) {
          <span class="trip-card__pill">{{ item.status }}</span>
        }
      </div>

      @if (item.kind === 'journey') {
        @for (row of item.journeyRows; track $index) {
          <div class="trip-card__rail-leg">
            <div class="trip-card__rail-leg-top">
              <span class="trip-card__rail-legtype">
                @if (row.label) {
                  <span class="trip-card__rail-label">{{ row.label }}</span>
                }
                @if (row.date) {
                  <span class="trip-card__rail-date">{{ row.date }}</span>
                }
              </span>
              @if (row.operator) {
                <span class="trip-card__rail-operator">{{ row.operator }}</span>
              }
            </div>
            <div
              class="trip-card__rail-route"
              [class.trip-card__rail-route--no-arrive-time]="!row.arriveTime"
            >
              <span class="trip-card__rail-point">
                @if (row.departTime) {
                  <span class="trip-card__rail-time">{{ row.departTime }}</span>
                }
                <span class="trip-card__rail-station">{{ row.departPoint }}</span>
              </span>
              <span class="trip-card__rail-arrow">→</span>
              <span class="trip-card__rail-point trip-card__rail-point--end">
                @if (row.arriveTime) {
                  <span class="trip-card__rail-time">{{ row.arriveTime }}</span>
                }
                <span class="trip-card__rail-station">{{ row.arrivePoint }}</span>
              </span>
            </div>
          </div>
        }
        @if (item.pnrLocator) {
          <div class="trip-card__ref">
            <span class="trip-card__ref-label" i18n="@@chatTripCardPnr">PNR:</span>
            {{ item.pnrLocator }}
          </div>
        }
        @if (item.supplierReference) {
          <div class="trip-card__ref">
            <span class="trip-card__ref-label" i18n="@@chatTripCardSupplierRef">Supplier Ref:</span>
            {{ item.supplierReference }}
          </div>
        }
      } @else if (item.kind === 'service') {
        @if (item.serviceDetail; as svc) {
          <div class="trip-card__hotel-name">{{ svc.title }}</div>
          @if (svc.subtitle) {
            <div class="trip-card__hotel-location">{{ svc.subtitle }}</div>
          }
          <div class="trip-card__hotel-stay">
            @for (row of svc.rows; track $index) {
              <span class="trip-card__hotel-stay-item">
                <span class="trip-card__hotel-stay-label">{{ row.label | translate }}</span>
                <span class="trip-card__hotel-stay-value">{{ row.value }}</span>
              </span>
            }
          </div>
        }
        @if (item.pnrLocator) {
          <div class="trip-card__ref">
            <span class="trip-card__ref-label" i18n="@@chatTripCardPnr">PNR:</span>
            {{ item.pnrLocator }}
          </div>
        }
        @if (item.supplierReference) {
          <div class="trip-card__ref">
            <span class="trip-card__ref-label" i18n="@@chatTripCardSupplierRef">Supplier Ref:</span>
            {{ item.supplierReference }}
          </div>
        }
      } @else if (item.kind === 'hotel') {
        <div class="trip-card__hotel-name">{{ item.hotelName }}</div>
        @if (item.hotelLocation) {
          <div class="trip-card__hotel-location">{{ item.hotelLocation }}</div>
        }
        <div class="trip-card__hotel-stay">
          <span class="trip-card__hotel-stay-item">
            <span class="trip-card__hotel-stay-label" i18n="@@chatTripCardCheckIn">Check-in</span>
            <span class="trip-card__hotel-stay-value">{{ item.checkIn }}</span>
          </span>
          <span class="trip-card__hotel-stay-item">
            <span class="trip-card__hotel-stay-label" i18n="@@chatTripCardCheckOut">Check-out</span>
            <span class="trip-card__hotel-stay-value">{{ item.checkOut }}</span>
          </span>
          @if (item.nights; as nights) {
            <span class="trip-card__hotel-stay-item">
              <span class="trip-card__hotel-stay-label" i18n="@@chatTripCardNights">Nights</span>
              <span class="trip-card__hotel-stay-value">{{ nights }}</span>
            </span>
          }
        </div>
        @if (item.pnrLocator) {
          <div class="trip-card__ref">
            <span class="trip-card__ref-label" i18n="@@chatTripCardPnr">PNR:</span>
            {{ item.pnrLocator }}
          </div>
        }
        @if (item.supplierReference) {
          <div class="trip-card__ref">
            <span class="trip-card__ref-label" i18n="@@chatTripCardSupplierRef">Supplier Ref:</span>
            {{ item.supplierReference }}
          </div>
        }
      } @else {
        <!-- Generic fallback for flight/car/etc. -->
        @if (item.genericDates) {
          <div class="trip-card__generic-dates">{{ item.genericDates }}</div>
        }
        @if (item.pnrLocator) {
          <div class="trip-card__ref">
            <span class="trip-card__ref-label" i18n="@@chatTripCardPnr">PNR:</span>
            {{ item.pnrLocator }}
          </div>
        }
        @if (item.supplierReference) {
          <div class="trip-card__ref">
            <span class="trip-card__ref-label" i18n="@@chatTripCardSupplierRef">Supplier Ref:</span>
            {{ item.supplierReference }}
          </div>
        }
      }

      <!-- Ticket delivery. Sits outside the kind branches: delivery hangs off the item, not
           the kind, so any product that starts returning it renders without a new branch. -->
      @if (item.delivery; as delivery) {
        <div class="trip-card__delivery">
          @switch (delivery.method) {
            @case ('ETICKET') {
              <span class="trip-card__delivery-label" i18n="@@chatTripCardETicket">E-ticket</span>
              @for (ticket of delivery.eTickets; track $index) {
                <div class="trip-card__delivery-ticket">
                  @if (delivery.eTickets.length > 1) {
                    <span class="trip-card__delivery-ticket-label">
                      <span i18n="@@chatTripCardTicketIndex">Ticket</span> {{ $index + 1 }}
                    </span>
                  }
                  @if (ticket.hasLinks) {
                    <span class="trip-card__delivery-links">
                      @if (ticket.pdfLink) {
                        <a
                          class="trip-card__delivery-link"
                          [href]="ticket.pdfLink"
                          target="_blank"
                          rel="noopener noreferrer"
                          i18n="@@chatTripCardDownloadPdf"
                          >Download PDF</a
                        >
                      }
                      @if (ticket.walletIos) {
                        <a
                          class="trip-card__delivery-link"
                          [href]="ticket.walletIos"
                          target="_blank"
                          rel="noopener noreferrer"
                          i18n="@@chatTripCardAppleWallet"
                          >Apple Wallet</a
                        >
                      }
                      @if (ticket.walletAndroid) {
                        <a
                          class="trip-card__delivery-link"
                          [href]="ticket.walletAndroid"
                          target="_blank"
                          rel="noopener noreferrer"
                          i18n="@@chatTripCardGoogleWallet"
                          >Google Wallet</a
                        >
                      }
                    </span>
                  } @else if (ticket.number) {
                    <span class="trip-card__delivery-note">
                      <span i18n="@@chatTripCardTicketNumber">Ticket number</span>
                      {{ ticket.number }}
                    </span>
                  }
                </div>
              }
            }
            @case ('TOD') {
              <span class="trip-card__delivery-label" i18n="@@chatTripCardTod"
                >Collect at station</span
              >
              <div class="trip-card__delivery-note" i18n="@@chatTripCardTodNote">
                Collect your tickets from a station ticket machine using this reference:
              </div>
              @for (reference of delivery.todReferences; track reference) {
                <span class="trip-card__delivery-ref">{{ reference }}</span>
              }
            }
            @case ('PRINT') {
              <span class="trip-card__delivery-label" i18n="@@chatTripCardDelivery"
                >Ticket delivery</span
              >
              <div class="trip-card__delivery-note">{{ delivery.note }}</div>
            }
          }
        </div>
      }
    </div>
  }
</div>
